import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDateInPast',
})
export class IsDateInPastPipe implements PipeTransform {
  public transform(value: string | Date | null | undefined): boolean {
    if (!value) {
      return false;
    }
    const date = value instanceof Date ? value : new Date(value);
    return date.getTime() < Date.now();
  }
}
